import React from "react";
import { useHistory } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));

const formatDate = (eDate, eTime) => {
  let dateData = new Date(eDate.split("T")[0]);
  let today = new Date(Date.now());
  let Difference_In_Days =
    (dateData.getTime() - today.getTime()) / (1000 * 3600 * 24);
  const days = Math.round(Difference_In_Days);
  //   console.log("days ", days);
  if (days < 1) {
    return `Toady at ${eTime}`;
  }
  //   console.log("Difference ", Difference_In_Days);
  return `in ${days} Days`;
};

const EventsList = ({ data }) => {
  const classes = useStyles();
  let history = useHistory();
  return (
    <>
      <div className={classes.root}>
        <Grid container spacing={3}>
          {data &&
            data.map((e) => (
              <Grid
                key={e._id}
                className="eventItem"
                item
                xs={12}
                sm={6}
                onClick={() => {
                  history.push({
                    pathname: `/event/${e._id}`,
                    state: e,
                  });
                }}
              >
                <Paper className={classes.paper}>
                  <h2 className="subTitle">{e.title}</h2>

                  <h3>{formatDate(e.date, e.time)}</h3>
                </Paper>
              </Grid>
            ))}
        </Grid>
      
      </div>
    </>
  );
};

export default EventsList;
